import { PlayerRef } from '@remotion/player';
import React from 'react';
import { Canvas } from './canvas/canvas';
import { Inspector } from './inspector/inspector';
import { PlaybackBar } from './playback-controls/playback-bar';
import { useLoop } from './utils/use-context';

export const TopPanel: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({ playerRef }) => {
  const loop = useLoop();

  return (
    <div className="relative h-full w-full flex-1">
      <div className="absolute flex h-full w-full flex-row">
        <div
          id="editor-canvas"
          className="flex min-h-0 flex-1 flex-col"
        >
          <Canvas
            playerRef={playerRef}
            loop={loop}
          />
          <PlaybackBar playerRef={playerRef} />
        </div>
        <div id="editor-inspector">
          <Inspector />
        </div>
      </div>
    </div>
  );
};
